<template>
	<div class="downList w69">
		<ul>
        <li v-for="(item,index) in dataList" :key='item.ID' class=" fadeInUp" :data-wow-delay="index/4+'s'">
            <router-link  :to="item.Url" :href="item.Url"  @click.native="OpenLink(item.Url)"  >
              <div class="time">
                  <p>{{setTimeformat(item.ShowTime6,'dd') }}</p>
                  <span>{{setTimeformat(item.ShowTime6,'yyyy/mm') }}</span>
              </div>
              <div class="title">
                  <h3>{{item.Title}}</h3>
                  <p>{{item.Describe}}</p>
              </div>
            </router-link>
        </li>
    </ul>
	</div>
</template>

<script>
	export default{
		name:'downList',
		props:{
			dataList:{
				type: Array,
				default: () => []
			},
			moreLink: {
			   type: String,
			   default: ''
			}
		},
		methods:{
			setTimeformat(_data,_format='yyyy-mm-dd'){
				return _format.replace(/YYYY/i,_data.substr(0,4)).replace(/MM/i,_data.substr(5,2)).replace(/DD/i,_data.substr(8,2))
			},
			hoverRoll(_data){
			    this.item = _data
			}
		}
	}
</script>

<style lang='less' scoped>
.downList{
	ul{
        li{
          width: 6.9rem;
		      height: 1.5rem;
		      background-color: #fbfbfb;
          margin-bottom: 0.2rem;
          &:last-child{
            margin-bottom: 0rem;
          }
          a{
            display: flex;
            flex-wrap: nowrap;
            justify-content: space-between;
            .time{
              width: 1.3rem;
              height: 1.5rem;
              box-sizing: border-box;
              margin: 0;
			  padding-top: 0.3rem;
              p{
                font-size: 0.68rem;
                font-weight: normal;
                font-stretch: normal;
                line-height: 1;
                letter-spacing: 0.03rem;
                color: #333333;
                // margin-bottom: 0.15rem;
                text-align: center;
              }
              span{
                display: block;
                font-size: 0.2rem;
                font-weight: normal;
                font-stretch: normal;
                line-height: 1;
                letter-spacing: 0.01rem;
                color: #999999;
                text-align: center;
              }
            }
            .title{
              width: 5.3rem;
              margin-right: 0.3rem;
              h3{
                font-size: 0.26rem;
                font-weight: bold;
                font-stretch: normal;
                line-height: 0.36rem;
                letter-spacing: 0.02rem;
                color: #333333;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                position: relative;
                margin-top: 0.25rem;
            }
            	p{
                font-size: 0.22rem;
                font-weight: normal;
                font-stretch: normal;
                line-height: 0.32rem;
                letter-spacing: 0.02rem;
                color: #666666;
                margin-top: 0.1rem;
                text-overflow: ellipsis;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
				}
            }
          }
        }
      }
}
</style>



// WEBPACK FOOTER //
// src/components/downList.vue